import config from '@src/config';

export const formatAmount = (amount, withCurrencySign = true) =>
    new Intl.NumberFormat('de-CH', {
        ...config.currencyConfig,
        style: withCurrencySign ? 'currency' : 'decimal',
    }).format(amount);
